import {
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { useActivoById, useGetActivoAmortizaciones } from "api/Activo.hook"
import { GetAmortizacionesDtoPropsProps } from "api/DTOs/GetAmortizacionesDto"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { ACTIVOID_COLUMNS } from "../constants/ActivoIdColumns"
import { TablaActivoIdEmptyTemplate } from "./TablaActivoIdEmptyTemplate"

export const TablaActivoId = ({ amortizar }: { amortizar: () => void }) => {
  const { t } = useTranslation()
  const { activoId } = useParams<{ activoId: string }>()

  const [pagination, setPagination] = useState({
    itemsPerPage: 10,
    skipCount: 0,
  })

  const {
    activoAmortizaciones,
    activoAmortizacionesIsLoading,
    activoAmortizacionesRefetch,
  } = useGetActivoAmortizaciones(activoId as string)

  const { activoByIdRefetch } = useActivoById(activoId)

  const refetchData = () => {
    activoAmortizacionesRefetch()
    activoByIdRefetch()
  }
  const totalItems = activoAmortizaciones?.items ?? []
  const paginatedItems = totalItems.slice(
    pagination.skipCount,
    pagination.skipCount + pagination.itemsPerPage
  )

  const dtRef =
    useRef<DataTablePrimeReact<GetAmortizacionesDtoPropsProps[]>>(null)
  return (
    <div className='tw-flex tw-flex-col tw-h-[calc(100%-357px)] tw-relative tw-bg-white'>
      <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
        <TableERP
          columns={ACTIVOID_COLUMNS(t, refetchData, activoId)}
          className='tw-h-full'
          columnResizeMode='expand'
          removableSort
          value={paginatedItems}
          showGridlines
          lazy
          dataKey='id'
          scrollable
          size='small'
          totalRecords={activoAmortizaciones?.totalCount ?? 0}
          loading={activoAmortizacionesIsLoading}
          emptyMessage={TablaActivoIdEmptyTemplate({ t, action: amortizar })}
        />
      </div>
      <PaginationERP
        className={PAGINATION_STYLES}
        totalRecords={activoAmortizaciones?.totalCount}
        first={pagination.skipCount}
        rows={pagination.itemsPerPage}
        resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
        setPagination={setPagination}
        optionDropdown={[10, 20, 50, 100]}
        texts={{
          textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
          textCurrentPageReport: `${t("pagination.from")}`,
        }}
      />
    </div>
  )
}
